import {
    combineReducers
} from "redux";
import message from "./message";
import auth from "./auth";
import projects from "./projects";

export default combineReducers({
    message,
    auth,
    projects
});


// WEBPACK FOOTER //
// ./src/Reducers/index.js